import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const SettingsPanel = ({ enableAdvice, setEnableAdvice, enableSound, setEnableSound, onChangeDeck }) => {
  const { t } = useLanguage();

  return (
    <div className="mt-6">
      {/* Settings Options */}
      <div 
        className="flex items-center justify-center gap-6 py-3 px-6 rounded-full mx-auto w-fit"
        style={{
          background: 'linear-gradient(145deg, rgba(26,26,46,0.9), rgba(22,33,62,0.9))',
          border: '1px solid rgba(255,215,0,0.2)',
          boxShadow: '0 4px 15px rgba(0,0,0,0.3)'
        }}
      >
        <button 
          onClick={() => setEnableAdvice(!enableAdvice)}
          className="flex items-center gap-2 cursor-pointer group"
        >
          <div 
            className={`w-5 h-5 rounded flex items-center justify-center transition-all ${
              enableAdvice ? 'scale-110' : ''
            }`}
            style={{
              background: enableAdvice ? 'linear-gradient(145deg, #ffd700, #b8860b)' : 'transparent',
              border: `2px solid ${enableAdvice ? '#ffd700' : '#666'}`,
              boxShadow: enableAdvice ? '0 0 10px rgba(255,215,0,0.5)' : 'none'
            }}
          >
            {enableAdvice && <span className="text-xs text-black font-bold">✓</span>}
          </div>
          <span className="text-sm font-medium group-hover:text-yellow-400 transition-colors" style={{ color: enableAdvice ? '#ffd700' : '#ccc' }}>
            💡 {t('advice')}
          </span>
        </button>

        <button 
          onClick={() => setEnableSound(!enableSound)}
          className="flex items-center gap-2 cursor-pointer group"
        >
          <div 
            className={`w-5 h-5 rounded flex items-center justify-center transition-all ${
              enableSound ? 'scale-110' : ''
            }`}
            style={{
              background: enableSound ? 'linear-gradient(145deg, #ffd700, #b8860b)' : 'transparent',
              border: `2px solid ${enableSound ? '#ffd700' : '#666'}`,
              boxShadow: enableSound ? '0 0 10px rgba(255,215,0,0.5)' : 'none'
            }}
          >
            {enableSound && <span className="text-xs text-black font-bold">✓</span>}
          </div>
          <span className="text-sm font-medium group-hover:text-yellow-400 transition-colors" style={{ color: enableSound ? '#ffd700' : '#ccc' }}>
            🔊 {t('sound')}
          </span>
        </button>

        <button
          onClick={onChangeDeck}
          className="px-4 py-1.5 rounded text-sm font-medium transition-all hover:scale-105"
          style={{
            background: 'rgba(255,215,0,0.1)',
            border: '1px solid rgba(255,215,0,0.3)',
            color: '#ffd700'
          }}
        >
          🎴 {t('changeDeck')}
        </button>
      </div>
    </div>
  );
};

export const ChangeDeckModal = ({ isOpen, onClose, currentDeck, onChangeDeck }) => {
  const { t } = useLanguage();
  const [selectedDeck, setSelectedDeck] = React.useState(currentDeck);

  if (!isOpen) return null;

  const decks = [
    { id: 'original', name: t('classicRed'), color: '#8B0000' },
    { id: 'blue', name: t('royalBlue'), color: '#00008B' },
    { id: 'black', name: t('midnightBlack'), color: '#1a1a2e' },
  ];

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50">
      <div 
        className="rounded-2xl p-6 w-96"
        style={{ 
          background: 'linear-gradient(145deg, #1a1a2e, #16213e)',
          border: '2px solid rgba(255,215,0,0.3)',
          boxShadow: '0 0 50px rgba(255,215,0,0.2)'
        }}
      >
        <h2 className="text-xl font-bold text-center mb-6" style={{ color: '#ffd700' }}>
          🎴 {t('selectDeckStyle')}
        </h2>
        
        <div className="space-y-3 mb-6">
          {decks.map((deck) => (
            <label 
              key={deck.id} 
              className={`flex items-center gap-4 p-3 rounded-lg cursor-pointer transition-all ${
                selectedDeck === deck.id ? 'scale-105' : 'hover:scale-102'
              }`}
              style={{
                background: selectedDeck === deck.id ? 'rgba(255,215,0,0.15)' : 'rgba(255,255,255,0.05)',
                border: `2px solid ${selectedDeck === deck.id ? '#ffd700' : 'transparent'}`
              }}
              onClick={() => setSelectedDeck(deck.id)}
            >
              <div 
                className="w-8 h-12 rounded"
                style={{ 
                  background: `linear-gradient(145deg, ${deck.color}, ${deck.color}88)`,
                  border: '2px solid #ffd700'
                }}
              ></div>
              <span style={{ color: '#e0e0e0' }}>{deck.name}</span>
            </label>
          ))}
        </div>

        <div className="flex gap-3">
          <button
            onClick={() => {
              onChangeDeck(selectedDeck);
              onClose();
            }}
            className="flex-1 py-3 rounded-lg font-bold transition-all hover:scale-105"
            style={{
              background: 'linear-gradient(145deg, #ffd700, #b8860b)',
              color: '#1a1a2e',
              boxShadow: '0 4px 15px rgba(255,215,0,0.3)'
            }}
          >
            {t('apply')}
          </button>
          <button
            onClick={onClose}
            className="flex-1 py-3 rounded-lg font-bold transition-all hover:scale-105"
            style={{
              background: 'rgba(255,255,255,0.1)',
              color: '#ccc',
              border: '1px solid rgba(255,255,255,0.2)'
            }}
          >
            {t('cancel')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel;
